import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { MenuUtility } from "@app/shared/services/utils/menu-utility.service";
import { User } from "@app/user/model/user";
import { Subject, takeUntil, tap } from "rxjs";

@Component({
    selector: "app-container",
    templateUrl: "./app-container.component.html",
    styleUrls: ["./app-container.component.scss"],
})
export class AppContainerComponent implements OnInit, OnChanges, OnDestroy {
    @Input() user: User;
    @Input() isEmbedded: boolean;
    @Input() isMobile: boolean;
    @Input() isFirstSignup = false;
    @ViewChild("sidenav") sidenav;

    public isSideNavOpen = false;

    private unsubscribe$ = new Subject();

    constructor(private readonly router: Router, private readonly menuService: MenuUtility) {}

    ngOnInit() {
        if (!this.isEmbedded && this.isMobile && this.sidenav) {
            this.sidenav.close();
        }

        this.router.events.subscribe(e => {
            if (this.isMobileAndSignedIn && e instanceof NavigationStart) {
                this.sidenav.close();
            }
        });

        this.menuService.menuOpen$
            .pipe(
                takeUntil(this.unsubscribe$),
                tap(menuOpenStatus => {
                    this.isSideNavOpen = menuOpenStatus.isOpen;
                    if (this.isMobile && !menuOpenStatus.isOpen) {
                        this.sidenav.close();
                    }
                })
            )
            .subscribe();
    }

    ngOnChanges(simpleChanges: SimpleChanges) {
        if (simpleChanges.isMobile && !this.isEmbedded && this.isMobile && this.sidenav) {
            this.sidenav.close();
        }
    }

    ngOnDestroy() {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }

    onToggleMenu() {
        this.sidenav.toggle();
        this.menuService.updateMenuState(this.sidenav.opened);
    }

    get isMobileAndSignedIn() {
        return !this.isEmbedded && this.isMobile && !!this.user?.id;
    }

    get isNotMobileAndSignedIn() {
        return !this.isMobile && !!this.user?.id;
    }
}
